function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b521c2fa\",\"scoped\":true,\"hasInlineConfig\":false}!../vue-loader/lib/selector?type=styles&index=0!./vue-datepicker-es6.vue")
}
var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./vue-datepicker-es6.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b521c2fa\",\"hasScoped\":true}!../vue-loader/lib/selector?type=template&index=0!./vue-datepicker-es6.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b521c2fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-datepicker/vue-datepicker-es6.vue
// module id = 44
// module chunks = 6